import {BrandPortalAttributeContext} from '@netx/core-cms-next/schema';
import {isBrandPortal, getCurrentPortalProp} from '@netx/core-cms-next/utils';
import {useAttributesStore} from '@netx/core-attribute/store/attributesStore';

export const getDefaultSortField = () => {
	if (!isBrandPortal()) return 'file';
	const sortField = getCurrentPortalProp('attributes')?.filter((portalAttr) => {
		return portalAttr[BrandPortalAttributeContext.SORT];
	});
	if (sortField?.length) {
		const attr = useAttributesStore
			.getState()
			.attributes.find(
				(attr) => attr.attributeid === sortField[0].attributeTemplateId,
			);
		return attr?.name || 'file';
	}
	return 'file';
};
